import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ImpersonationConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CustomerImpersonationService } from './api/customerImpersonation.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ImpersonationApiModule {
    public static forRoot(configurationFactory: () => ImpersonationConfiguration): ModuleWithProviders<ImpersonationApiModule> {
        return {
            ngModule: ImpersonationApiModule,
            providers: [ { provide: ImpersonationConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ImpersonationApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ImpersonationApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
